module.exports = __webpack_public_path__ + "static/media/so-icon--paw.7055a891.svg";